import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import calculateSetPrice from '../helper/calculate_set_price';

class TyreStoreClass extends ReduceStore {
    getInitialState() {
        return {
            id: '',
            tyreImage: '',
            model: '',
            brand: '',
            brandImage: '',
            size: '',
            qty: 0,
            price: 0,
            currencyHTML: '',
            setPrice: 0,
            buy4pay3: false,
            clearance: false,
            off15Perc: false,
            cashback100: false,
            freefitting: false,
            availableQuantities: [],
            ean: '',
            availability: ''
        };
    }

    reduce(state, {source, action}) {
        if (source === 'TYRE_ACTION') {
            switch (action.type) {
                case 'UPDATE_QTY':
                    if (state.qty !== action.payload) {
                        state.qty = action.payload;
                        state.setPrice = calculateSetPrice(state.qty, state.price, {
                            buy4pay3: state.buy4pay3,
                            off15: state.off15Perc,
                            cashback100: state.cashback100
                        });
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_QTY_OPTIONS':
                    if (state.availableQuantities !== action.payload) {
                        state.availableQuantities = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_TYRE_IMAGE':
                    if (state.tyreImage === '') {
                        state.tyreImage = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_PRICE':
                    if (state.price === 0) {
                        state.price = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_CURRENCY_HTML':
                    if (state.currencyHTML === '') {
                        state.currencyHTML = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_ID':
                    if (state.id === '') {
                        state.id = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_BRAND':
                    if (state.brand === '') {
                        state.brand = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_BRAND_IMAGE':
                    if (state.brandImage === '') {
                        state.brandImage = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_MODEL':
                    if (state.model === '') {
                        state.model = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_SIZE':
                    if (state.size === '') {
                        state.size = action.payload;
                        this.__emitChange();
                    }
                    break;

                case 'UPDATE_BUY4PAY3':
                    state.buy4pay3 = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_CLEARANCE':
                    state.clearance = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_15OFF':
                    state.off15Perc = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_10OCASHBACK':
                    state.cashback100 = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_FREEFITTING':
                    state.freefitting = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_AVAILABILITY':
                    state.availability = action.payload;
                    this.__emitChange();
                    break;

                case 'UPDATE_EAN':
                    state.ean = action.payload;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const TyreStore = new TyreStoreClass(Dispatcher);
export default TyreStore;
